var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "DialogBase",
    {
      attrs: {
        title: "Gửi thông báo qua Onekids",
        visible: _vm.isVisible,
        "dialog-class": "sk-dialog--md",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isVisible = $event
        },
        close: _vm.handleClose,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "sk-dialog__footer" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-cancel",
                      attrs: { plain: "" },
                      on: { click: _vm.handleClose },
                    },
                    [_vm._v("Hủy")]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "btn-save",
                      attrs: { type: "primary", loading: _vm.isSaving },
                      on: { click: _vm.handleSave },
                    },
                    [_vm._v("\n        Gửi thông báo\n      ")]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "sk-dialog__content" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _vm.formData,
                rules: _vm.formRules,
                "label-position": "top",
                "label-width": "auto",
              },
            },
            [
              _c(
                "div",
                { staticClass: "sk-panel" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c("div", { staticClass: "sk-panel-icon" }, [
                      _c("i", { staticClass: "el-icon-message" }),
                    ]),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Nội dung thông báo"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Tiêu đề và nội dung gửi qua ứng dụng Onekids"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Tiêu đề", prop: "sendTitle" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "Nhập tiêu đề thông báo" },
                        model: {
                          value: _vm.formData.sendTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "sendTitle", $$v)
                          },
                          expression: "formData.sendTitle",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "sk-u-mt-12",
                      attrs: { label: "Nội dung", prop: "sendContent" },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 6,
                          placeholder: "Nhập nội dung thông báo...",
                        },
                        model: {
                          value: _vm.formData.sendContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "sendContent", $$v)
                          },
                          expression: "formData.sendContent",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "sk-panel sk-u-mt-12" },
                [
                  _c("div", { staticClass: "sk-panel-head" }, [
                    _c(
                      "div",
                      { staticClass: "sk-panel-icon sk-panel-icon--success" },
                      [_c("i", { staticClass: "el-icon-paperclip" })]
                    ),
                    _c("div", [
                      _c("p", { staticClass: "sk-panel-title" }, [
                        _vm._v("Đính kèm"),
                      ]),
                      _c("p", { staticClass: "sk-panel-subtitle" }, [
                        _vm._v("Tùy chọn đính kèm hóa đơn và tệp tin bổ sung"),
                      ]),
                    ]),
                  ]),
                  _c("el-form-item", [
                    _c(
                      "div",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.formData.statusAttachNotifyFinance,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.formData,
                                  "statusAttachNotifyFinance",
                                  $$v
                                )
                              },
                              expression: "formData.statusAttachNotifyFinance",
                            },
                          },
                          [_vm._v("Đính kèm thông tin học phí")]
                        ),
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.formData.attachOrderPDF,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "attachOrderPDF", $$v)
                              },
                              expression: "formData.attachOrderPDF",
                            },
                          },
                          [_vm._v("Đính kèm ảnh hóa đơn học phí")]
                        ),
                      ],
                      1
                    ),
                    _vm.formData.statusAttachNotifyFinance
                      ? _c(
                          "div",
                          {
                            staticClass: "sk-note sk-note--warning sk-u-mt-12",
                          },
                          [
                            _c("i", { staticClass: "el-icon-warning-outline" }),
                            _c("span", [
                              _vm._v(
                                "Nội dung của bạn sẽ được đính kèm theo cả thông báo học phí!"
                              ),
                            ]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "sk-u-mt-12",
                      attrs: {
                        label: "File đính kèm (Tối đa 3 file, mỗi file ≤ 5MB)",
                      },
                    },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          attrs: {
                            action: "",
                            "auto-upload": false,
                            multiple: "",
                            limit: 5,
                            "file-list": _vm.fileList,
                            "on-change": _vm.toggleUpload,
                            "on-remove": _vm.handleRemove,
                            "before-remove": _vm.beforeRemove,
                            "on-exceed": _vm.handleExceed,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                plain: "",
                                icon: "el-icon-upload2",
                              },
                            },
                            [_vm._v("Tải lên file đính kèm")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }